<template>
  <base-form :title="title"
             :loading="submitLoading"
             @submit="submitForm">
    <div v-if="suggestion">
      <fg-input :label="$t('generic.jobBoard')" :error="getError($t('generic.jobBoard'))">
        <job-board-autocomplete :placeholder="$t('generic.jobBoard')"
                                :name="$t('generic.jobBoard')"
                                clearable
                                v-model="suggestion.job_board_id">
        </job-board-autocomplete>
      </fg-input>

      <fg-input :label="$t('searchSuggestions.list.keyword')"
                :error="getError($t('searchSuggestions.list.keyword'))"
                :name="$t('searchSuggestions.list.keyword')"
                v-model="suggestion.keyword"
                v-validate="'required'">
      </fg-input>

      <section-separator has-border size="lg">
        {{$t('searchSuggestions.list.query')}}
      </section-separator>
      <fg-input :label="$t('generic.segments')">
        <segment-autocomplete :placeholder="$t('generic.segments')"
                              multiple
                              v-model="suggestion.query.segments">
        </segment-autocomplete>
      </fg-input>

      <fg-input :label="$t('searchSuggestions.searchKeywords')">
        <el-select v-model="suggestion.query.search"
                   :placeholder="$t('searchSuggestions.searchKeywords')"
                   filterable
                   multiple
                   allow-create
                   default-first-option
                   class="select-info">
          <el-option :label="$t('searchSuggestions.defaultOption')" value="default" class="select-info"
                     disabled></el-option>
        </el-select>
      </fg-input>
      <fg-input :label="$t('searchSuggestions.excludeSearchKeywords')">
        <el-select v-model="suggestion.query.exclude_search"
                   :placeholder="$t('searchSuggestions.excludeSearchKeywords')"
                   filterable
                   multiple
                   allow-create
                   default-first-option
                   class="select-danger">
          <el-option :label="$t('searchSuggestions.defaultOption')" value="default" class="select-danger"
                     disabled></el-option>
        </el-select>
      </fg-input>
    </div>
  </base-form>
</template>
<script>
  import SegmentAutocomplete from 'src/components/Autocomplete/SegmentAutocomplete'
  import JobBoardAutocomplete from 'src/components/Autocomplete/JobBoardAutocomplete'
  import { Select, Option } from 'element-ui'

  let defaultQuery = {
    segments: [],
    search: [],
    exclude_search: []
  }
  export default {
    components: {
      SegmentAutocomplete,
      JobBoardAutocomplete,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
      title: String,
      submitLoading: Boolean,
    },
    data () {
      return {
        suggestion: {
          job_board_id: null,
          keyword: '',
          query: {
            ...defaultQuery
          }
        },
      }
    },
    methods: {
      async submitForm () {
        let isFormValid = await this.$validator.validateAll()
        if (!isFormValid) {
          return
        }
        this.$emit('submit', this.suggestion)
      },
      validateQuery (query) {
        let keys = ['segments', 'search', 'exclude_search']
        if (!query) {
          return {
            ...defaultQuery
          }
        }
        keys.forEach(key => {
          if (!query[key]) {
            query[key] = []
          }
        })
        return query
      }
    },
    watch: {
      data: {
        immediate: true,
        handler(newVal) {
          if (!newVal) {
            return
          }
          this.suggestion = {
            ...newVal
          }
          this.suggestion.query = this.validateQuery(newVal.query)
        }
      }
    }
  }
</script>
<style>
</style>
